import React, { useState } from "react";
import {
  Box,
  Container,
  Paper,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { verifyAccessCode } from "../../services/api";
import LoadingSpinner from "../common/LoadingSpinner";
import Alert from "../common/Alert";

const PasswordProtection = ({ onAuthenticated, userData }) => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!code) {
      setError("Access code is required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await verifyAccessCode({ code, email: userData.email });
      localStorage.setItem("loanAppAuth", "true");
      localStorage.setItem("loanAppAuthTime", Date.now().toString());
      onAuthenticated();
    } catch (err) {
      setAlert({
        open: true,
        severity: "error",
        message: err.message || "Incorrect code. Please try again.",
      });
      setCode("");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseAlert = () => {
    setAlert((prev) => ({ ...prev, open: false }));
  };

  if (loading) {
    return <LoadingSpinner message="Verifying code..." />;
  }

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        bgcolor: "background.default",
      }}
    >
      <Container maxWidth="sm">
        <Paper sx={{ p: 4, textAlign: "center" }}>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 80,
              height: 80,
              borderRadius: "50%",
              bgcolor: "primary.main",
              color: "white",
              mb: 3,
            }}
          >
            <LockIcon sx={{ fontSize: 40 }} />
          </Box>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
            Enter Access Code
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
            We've sent a 6-digit code to:
          </Typography>
          <Typography
            variant="body2"
            color="primary.main"
            sx={{ fontWeight: 600, mb: 1 }}
          >
            {userData.phone}
          </Typography>
          <Typography
            variant="body2"
            color="primary.main"
            sx={{ fontWeight: 600, mb: 4 }}
          >
            {userData.email}
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Access Code"
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                setError("");
              }}
              error={!!error}
              helperText={error}
              sx={{ mb: 3 }}
              autoFocus
              inputProps={{
                maxLength: 6,
                style: {
                  textAlign: "center",
                  fontSize: "1.5rem",
                  letterSpacing: "0.5rem",
                },
              }}
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              size="large"
              sx={{ py: 1.5 }}
            >
              Verify Code
            </Button>
          </form>
        </Paper>
      </Container>

      <Alert
        open={alert.open}
        onClose={handleCloseAlert}
        severity={alert.severity}
        message={alert.message}
      />
    </Box>
  );
};

export default PasswordProtection;
